import React from "react";
import ProductsContainer from "../containers/ProductsContainer";

export default function Products() {
  return <ProductsContainer />;
}
